<section>
  <app-apply-to-all (appliedToAll)="this.validateAccounts()" [dataSource]="dataSource"></app-apply-to-all>
  <h2 class="title" *ngIf="this.title">{{this.title}}</h2>
  <p class="description" *ngIf="this.description">{{this.description}}</p>
  <div *ngIf="utilityAccounts">
    <div class="buttons">
      <p id="gridInstruction" *ngIf="quoteRequestState.quoteRequestType === 'Matrix' || quoteRequestState.quoteRequestType === 'Custom'">
        Copy and paste or enter the details for the accounts you would like to quote for below.
      </p>
      <span class="flex-fill"></span>
      <div *ngIf="!isReadOnly && utilityAccounts?.length > 0">
        <a (click)="removeInvalidUAs()" class="download-link">{{'Remove Invalid ' + getAccountName(utilityInformation) + 's'}}</a>&nbsp;
        <span class="download-link">|</span>&nbsp; <a (click)="removeAllUAs()" class="download-link">{{'Remove All ' + getAccountName(utilityInformation) + 's'}}</a>
      </div>
    </div>
    <table id="utilityAccountsTable" mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="UtilityAccountNumber">
        <th mat-header-cell *matHeaderCellDef>{{getAccountName(utilityInformation)}}</th>
        <td mat-cell *matCellDef="let utilityAccount" class="col-large">
          <input
            [disabled]="isReadOnly"
            class="full-cell"
            type="text"
            placeholder="{{'Enter ' + getAccountName(utilityInformation)}}"
            [(ngModel)]="utilityAccount.utilityAccountNumber"
            (input)="rowChanged(utilityAccount)"
            [class.invalid]="propInvalid(utilityAccount, 'utilityAccountNumber')"
          />
        </td>

        <td mat-footer-cell *matFooterCellDef class="col-large">
          <input
            [disabled]="isReadOnly"
            #uanFooter
            id="utilityAccountNumber"
            class="full-cell"
            [class.invalid]="this.footerUanInvalid && this.footerPartiallyCompleted"
            [(ngModel)]="newAccountsData.utilityAccountNumber"
            type="text"
            required
            (paste)="onPaste($event)"
            (blur)="this.storeRow()"
            placeholder="{{'Enter ' + getAccountName(utilityInformation)}}"
            pattern="(.|\s)*\S(.|\s)*"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="MeterNumber">
        <ng-container  *ngIf="utilityInformation?.meterNumberIsMandatory">
          <th mat-header-cell  [hidden]="dontShowMeterNumberColumn" *matHeaderCellDef>Meter Number</th>
        </ng-container>
        <ng-container *ngIf="!utilityInformation?.meterNumberIsMandatory">
          <th mat-header-cell [hidden]="dontShowMeterNumberColumn" *matHeaderCellDef>Meter Number(<i>Optional</i>)</th>
        </ng-container>
        <td mat-cell [hidden]="dontShowMeterNumberColumn" *matCellDef="let utilityAccount">
          <input
            [disabled]="isReadOnly"
            class="full-cell"
            type="text"
            placeholder="Enter Meter Number"
            [(ngModel)]="utilityAccount.meterNumber"
            (input)="rowChanged(utilityAccount)"
            [class.invalid]="propInvalid(utilityAccount, 'meterNumber')"
          />
        </td>

        <td mat-footer-cell  [hidden]="dontShowMeterNumberColumn" *matFooterCellDef>
          <input
            [disabled]="isReadOnly"
            #meterNumberFooter
            id="meterNumber"
            class="full-cell"
            [class.invalid]="this.footerMeterNumberInvalid && this.footerPartiallyCompleted"
            [(ngModel)]="newAccountsData.meterNumber"
            type="text"
            required
            (paste)="onPaste($event)"
            (blur)="this.storeRow()"
            placeholder="Enter Meter Number"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="RateCode">
        <th mat-header-cell *matHeaderCellDef>Load Profile</th>
        <td mat-cell *matCellDef="let utilityAccount">
            <select  id="rateCode"
                    class="full-cell"
                    [disabled]="isReadOnly || !hasRateCodes(utilityAccount)"
                    [(ngModel)]="utilityAccount.rateCode"
                    (change)="rateCodeChanged(utilityAccount)"
                    [class.invalid]="propInvalid(utilityAccount, 'rateCode')">
              <option value="">
                {{ this.loadingRateCodes[utilityAccount?.utilityDetails?.utilityShort] ? 'Loading...' : '-- Please Select --' }}
              </option>
              <option *ngFor="let rateCodeDetails of findRateCodes(utilityAccount)" [ngValue]="rateCodeDetails.rateCode">
                {{ rateCodeDetails.rateCode }}
              </option>
            </select>
</td>

        <td mat-footer-cell *matFooterCellDef>
          <select #rateCodeFooter
                  [disabled]="isReadOnly || !hasRateCodes(newAccountsData)"
                  mat-select
                  id="rateCodeFooter"
                  class="full-cell"
                  pattern="(.|\s)*\S(.|\s)*"
                  [(ngModel)]="newAccountsData.rateCodeDetails"
                  [ngModel]="newAccountsData.rateCodeDetails || ''"
                  [class.invalid]="(this.footerRateCodeInvalid && this.footerPartiallyCompleted) || propInvalid(newAccountsData, 'rateCode')"
                  (blur)="this.storeRow()">
            <option selected="selected" default value="">
              <span id="defaultOption">{{ this.loadingRateCodes[newAccountsData?.utilityDetails?.utilityShort] ? 'Loading...' : '-- Please Select --' }}</span>
            </option>
            <option *ngFor="let rateCodeDetails of findRateCodes(newAccountsData)" [ngValue]="rateCodeDetails" class="blackText">
              {{ rateCodeDetails.rateCode }}
            </option>
          </select>
        </td>
      </ng-container>

      <ng-container matColumnDef="NewContractStartDate">
        <th mat-header-cell *matHeaderCellDef>New Contract Start Month</th>
        <td mat-cell *matCellDef="let utilityAccount; let i = index">
          <div [class.date-cell-invalid]="propInvalid(utilityAccount, 'newContractStartDate')">
            <input [name]="'datepicker'+i"
                   id="'newContractStartDate' + i"
                   autocomplete="new-password"
                   [disabled]="isReadOnly"
                   [matDatepicker]="newContractStartDate"
                   class="date-cell"
                   [class.invalid]="true"
                   [min]="minDate"
                   placeholder="-- Please Select --"
                   [(ngModel)]="utilityAccount.newContractStartDate" />
            <mat-datepicker-toggle matSuffix [for]="newContractStartDate"></mat-datepicker-toggle>
            <mat-datepicker color="accent"
                            #newContractStartDate="matDatepicker"
                            startView="multi-year"
                            (monthSelected)="chosenMonthHandler($event, newContractStartDate, utilityAccount, false)"></mat-datepicker>
          </div>
        </td>

        <td mat-footer-cell *matFooterCellDef >
          <div [class.date-cell-invalid]="this.footerStartDateInvalid && this.footerPartiallyCompleted">
            <input
              id="newContractStartDateFooter"
              autocomplete="new-password"
              [name]="'datepickerFooter'"
              [disabled]="isReadOnly"
              matInput
              [matDatepicker]="footerDatepicker"
              class="date-cell"
              [min]="minDate"
              placeholder="-- Please Select --"
              (click)="
                this.storeRow({
                  newContractStartDate: newAccountsData.newContractStartDate,
                  utilityAccountNumber: newAccountsData.utilityAccountNumber,
                  rateCodeDetails: newAccountsData.rateCodeDetails,
                  consumptionData: newAccountsData.consumptionData
                })
              "
              [(ngModel)]="newAccountsData.newContractStartDate"
            />
            <mat-datepicker-toggle matSuffix [for]="footerDatepicker"></mat-datepicker-toggle>
            <mat-datepicker
              color="accent"
              #footerDatepicker ="matDatepicker"
              startView="multi-year"
              (monthSelected)="chosenMonthHandler($event, footerDatepicker, newAccountsData, true)"
            ></mat-datepicker>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="NameKey">
        <th mat-header-cell *matHeaderCellDef>Name Key</th>
        <td mat-cell *matCellDef="let utilityAccount">
          <input
            [disabled]="isReadOnly"
            class="full-cell"
            type="text"
            placeholder="Enter Name Key"
            [(ngModel)]="utilityAccount.nameKey"
            (input)="rowChanged(utilityAccount)"
            [class.invalid]="propInvalid(utilityAccount, 'nameKey')"
          />
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <input
            [disabled]="isReadOnly"
            #nameKeyFooter
            id="nameKey"
            class="full-cell"
            [class.invalid]="this.footerNameKeyInvalid && this.footerPartiallyCompleted"
            [(ngModel)]="newAccountsData.nameKey"
            type="text"
            required
            (paste)="onPaste($event)"
            (blur)="this.storeRow()"
            placeholder="Enter Name Key"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="ServiceKey">
        <th mat-header-cell *matHeaderCellDef>Service Key</th>
        <td mat-cell *matCellDef="let utilityAccount">
          <input
            [disabled]="isReadOnly"
            class="full-cell"
            type="text"
            placeholder="Enter Service Key"
            [(ngModel)]="utilityAccount.serviceKey"
            (input)="rowChanged(utilityAccount)"
            [class.invalid]="propInvalid(utilityAccount, 'serviceKey')"
          />
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <input
            [disabled]="isReadOnly"
            #serviceKeyFooter
            id="serviceKey"
            class="full-cell"
            [class.invalid]="this.footerServiceKeyInvalid && this.footerPartiallyCompleted"
            [(ngModel)]="newAccountsData.serviceKey"
            type="text"
            required
            (paste)="onPaste($event)"
            (blur)="this.storeRow()"
            placeholder="Enter Service Key"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="ZipCode">
        <th mat-header-cell *matHeaderCellDef>Zip Code</th>

        <td mat-cell *matCellDef="let utilityAccount" class="col-small">
          <div style="position: relative;">
            <input
              [disabled]="isReadOnly"
              class="full-cell"
              type="text"
              placeholder="Enter Zip Code"
              [(ngModel)]="utilityAccount.address.zipCode"
              (input)="rowChanged(utilityAccount); zipLookup(utilityAccount)"
              [class.invalid]="propInvalid(utilityAccount, 'zipCode')"
              id="zip-code"
            />
            <mat-spinner
              *ngIf="zipCodeLoadingMap[utilityAccount.utilityAccountNumber]"
              [diameter]="16"
              color="accent"
              id="zip-code-lookup"
            ></mat-spinner>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef class="col-small">
          <div style="position: relative;">
            <input
              [disabled]="isReadOnly"
              #zipCodeFooter
              id="zipCode"
              class="full-cell"
              [(ngModel)]="newAccountsData.address.zipCode"
              type="text"
              required
              (blur)="storeRow(); zipLookup(newAccountsData, true)"
              (input)="zipLookup(newAccountsData)"
              placeholder="Enter Zip Code"
              [class.invalid]="(footerZipCodeInvalid && footerPartiallyCompleted) || propInvalid(newAccountsData, 'zipCode')"
              id="zip-code"
            />
            <mat-spinner
              *ngIf="zipCodeLoadingMap[newAccountsData.utilityAccountNumber]"
              [diameter]="16"
              color="accent"
              id="zip-code-lookup"
            ></mat-spinner>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="City">
        <th mat-header-cell *matHeaderCellDef>City</th>
        <td mat-cell *matCellDef="let utilityAccount">
          <input
            disabled
            class="full-cell"
            type="text"
            placeholder="City"
            [(ngModel)]="utilityAccount.address.city"
            (input)="rowChanged(utilityAccount)"
          />
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <input
            disabled
            #cityFooter
            id="city"
            class="full-cell"
            [(ngModel)]="newAccountsData.address.city"
            type="text"
            required
            (blur)="storeRow()"
            placeholder="City"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="State">
        <th mat-header-cell *matHeaderCellDef>State</th>
        <td mat-cell *matCellDef="let utilityAccount" class="col-small">
          <input
            disabled
            class="full-cell"
            type="text"
            placeholder="State"
            [(ngModel)]="utilityAccount.address.state"
            (input)="rowChanged(utilityAccount)"
          />
        </td>

        <td mat-footer-cell *matFooterCellDef class="col-small">
          <input
            disabled
            #stateFooter
            id="state"
            class="full-cell"
            [(ngModel)]="newAccountsData.address.state"
            type="text"
            required
            (blur)="storeRow()"
            placeholder="State"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="StreetAddress1">
        <th mat-header-cell *matHeaderCellDef>Street Address 1</th>
        <td mat-cell *matCellDef="let utilityAccount">
          <input
            [disabled]="isReadOnly"
            class="full-cell"
            type="text"
            placeholder="Enter Street Address 1"
            [(ngModel)]="utilityAccount.address.addressLine1"
            (input)="rowChanged(utilityAccount)"
            [class.invalid]="propInvalid(utilityAccount, 'addressLine1')"
          />
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <input
            [disabled]="isReadOnly"
            #streetAddress1Footer
            id="streetAddress1"
            class="full-cell"
            [(ngModel)]="newAccountsData.address.addressLine1"
            type="text"
            required
            (blur)="storeRow()"
            placeholder="Enter Street Address 1"
            [class.invalid]="this.footerStreetAddress1Invalid && this.footerPartiallyCompleted"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="StreetAddress2">
        <th mat-header-cell *matHeaderCellDef>Street Address 2</th>
        <td mat-cell *matCellDef="let utilityAccount">
          <input
            [disabled]="isReadOnly"
            class="full-cell"
            type="text"
            placeholder="Enter Street Address 2"
            [(ngModel)]="utilityAccount.address.addressLine2"
            (input)="rowChanged(utilityAccount)"
            [class.invalid]="propInvalid(utilityAccount, 'streetAddress2')"
          />
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <input
            [disabled]="isReadOnly"
            #streetAddress2Footer
            id="streetAddress1"
            class="full-cell"
            [(ngModel)]="newAccountsData.address.addressLine2"
            type="text"
            required
            (blur)="storeRow()"
            placeholder="Enter Street Address 2"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="Utility">
        <th mat-header-cell *matHeaderCellDef>Utility</th>

        <td mat-cell *matCellDef="let utilityAccount">
          <select
            id="utility"
            class="full-cell"
            [disabled]="isReadOnly || !hasMoreThanOneUtility(utilityAccount.address.zipCode)"
            [(ngModel)]="utilityAccount.utilityDetails.utilityShort"
            [ngModel]="utilityAccount.utilityDetails.utilityShort || ''"
            [class.invalid]="propInvalid(utilityAccount, 'utilityShort')"
            (blur)="this.storeRow()"
            (change)="onUtilitySelected(utilityAccount)"
          >
            <option value="">
              <span id="defaultOption">-- Please Select --</span>
            </option>
            <option *ngFor="let utility of findUtilities(utilityAccount.address.zipCode)" [value]="utility.utilityShort">
              {{ utility.utilityShort }}
            </option>
          </select>
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <select
            #utilityFooter
            [disabled]="isReadOnly || !hasMoreThanOneUtility(newAccountsData.address.zipCode)"
            mat-select
            id="utilityFooter"
            class="full-cell"
            [(ngModel)]="newAccountsData.utilityDetails.utilityShort"
            [ngModel]="newAccountsData.utilityDetails.utilityShort || ''"
            [class.invalid]="(footerUtilityInvalid && footerPartiallyCompleted) || propInvalid(newAccountsData, 'utilityShort')"
            (blur)="storeRow()"
            (change)="onUtilitySelected(newAccountsData)"
          >
            <option selected="selected" value="">
              <span id="defaultOption">-- Please Select --</span>
            </option>
            <option *ngFor="let utility of findUtilities(newAccountsData.address.zipCode)" [value]="utility.utilityShort" class="blackText">
              {{ utility.utilityShort }}
            </option>
          </select>
        </td>
      </ng-container>

      <ng-container matColumnDef="ISO">
        <th mat-header-cell *matHeaderCellDef>ISO</th>
        <td mat-cell *matCellDef="let utilityAccount" class="col-small">
          <input
            disabled
            class="full-cell"
            type="text"
            placeholder="ISO"
            [(ngModel)]="utilityAccount.utilityDetails.iso"
            (input)="rowChanged(utilityAccount)"
          />
        </td>

        <td mat-footer-cell *matFooterCellDef class="col-small">
          <input
            disabled
            #isoFooter
            id="iso"
            class="full-cell"
            [(ngModel)]="newAccountsData.utilityDetails.iso"
            type="text"
            required
            (blur)="storeRow()"
            placeholder="ISO"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="Zone">
        <th mat-header-cell *matHeaderCellDef>Zone</th>

        <td mat-cell *matCellDef="let utilityAccount">
          <select
            id="zone"
            class="full-cell"
            [disabled]="isReadOnly || !hasMoreThanOneUtilityZone(utilityAccount.address.zipCode, utilityAccount.utilityDetails.utilityShort)"
            [(ngModel)]="utilityAccount.utilityDetails.zone"
            [ngModel]="utilityAccount.utilityDetails.zone || ''"
            [class.invalid]="propInvalid(utilityAccount, 'zone')"
          >
            <option value="">-- Please Select --</option>
            <option *ngFor="let utilityZoneInformation of findZoneInformation(utilityAccount.address.zipCode, utilityAccount.utilityDetails.utilityShort)" [value]="utilityZoneInformation.loadZone">
              {{ utilityZoneInformation.loadZone }}
            </option>
          </select>
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <select
            #zoneFooter
            [disabled]="isReadOnly || !hasMoreThanOneUtilityZone(newAccountsData.address.zipCode, newAccountsData.utilityDetails.utilityShort)"
            mat-select
            id="zoneFooter"
            class="full-cell"
            [(ngModel)]="newAccountsData.utilityDetails.zone"
            [ngModel]="newAccountsData.utilityDetails.zone || ''"
            [class.invalid]="footerZoneInvalid && footerPartiallyCompleted"
            (blur)="storeRow()"
          >
            <option selected="selected" value="">
              <span id="defaultOption">-- Please Select --</span>
            </option>
            <option *ngFor="let utilityZoneInformation of findZoneInformation(newAccountsData.address.zipCode, newAccountsData.utilityDetails.utilityShort)" [value]="utilityZoneInformation.loadZone" class="blackText">
              {{ utilityZoneInformation.loadZone }}
            </option>
          </select>
        </td>
      </ng-container>

      <ng-container matColumnDef="WeatherZone">
        <th mat-header-cell *matHeaderCellDef>Weather Zone</th>

        <td mat-cell *matCellDef="let utilityAccount">
          <select
            id="weatherZone"
            class="full-cell"
            [disabled]="isReadOnly || !hasMoreThanOneUtilityZone(utilityAccount.address.zipCode, utilityAccount.utilityDetails.utilityShort)"
            [(ngModel)]="utilityAccount.utilityDetails.weatherZone"
            [class.invalid]="propInvalid(utilityAccount, 'weatherZone')"
          >
            <option value="">-- Please Select --</option>
            <option *ngFor="let utilityZoneInformation of findZoneInformation(utilityAccount.address.zipCode, utilityAccount.utilityDetails.utilityShort)" [value]="utilityZoneInformation.weatherZone">
              {{ utilityZoneInformation.weatherZone ? utilityZoneInformation.weatherZone : 'N/A' }}
            </option>
          </select>
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <select
            #weatherZoneFooter
            [disabled]="isReadOnly || !hasMoreThanOneUtilityZone(newAccountsData.address.zipCode, newAccountsData.utilityDetails.utilityShort)"
            mat-select
            id="weatherZoneFooter"
            class="full-cell"
            [(ngModel)]="newAccountsData.utilityDetails.weatherZone"
            [class.invalid]="footerWeatherZoneInvalid && footerPartiallyCompleted"
            (blur)="storeRow()"
          >
            <option selected="selected" value="">
              <span id="defaultOption">-- Please Select --</span>
            </option>
            <option *ngFor="let utilityZoneInformation of findZoneInformation(newAccountsData.address.zipCode, newAccountsData.utilityDetails.utilityShort)" [value]="utilityZoneInformation.weatherZone" class="blackText">
              {{ utilityZoneInformation.weatherZone ? utilityZoneInformation.weatherZone : 'N/A' }}
            </option>
          </select>
        </td>
      </ng-container>

      <ng-container matColumnDef="Errors">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let utilityAccount">
          <mat-icon
            [ngStyle]="{ color: 'red' }"
            matTooltipPosition="right"
            data-html="true"
            *ngIf="utilityAccount.validationInfo?.valid === false && !isReadOnly"
            matTooltipClass="enable-line-break ud-tooltip"
            [matTooltip]="getFullValidationMessage(utilityAccount) | async"
            >error</mat-icon
          >
        </td>

        <td mat-footer-cell *matFooterCellDef>
          <mat-icon
            [ngStyle]="{ color: 'red' }"
            matTooltipPosition="right"
            data-html="true"
            *ngIf="newAccountsData.validationInfo?.valid === false"
            matTooltipClass="enable-line-break ud-tooltip"
            [matTooltip]="getFullValidationMessage(newAccountsData) | async"
          >
            error</mat-icon
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let utilityAccount">
          <button
            [disabled]="isReadOnly"
            class="btn_remove"
            mat-stroked-button
            color="accent"
            (click)="removeUtilityAccount(utilityAccount)"
          >
            <mat-icon matPrefix color="accent">delete</mat-icon>Remove
          </button>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <ng-container *ngIf="showNewUtilityAccountInput">
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </ng-container>
    </table>

    <div class="error-box top-m-2x">
      <mat-error *ngIf="validityChecked && !utilityAccounts?.length">Please enter at least one valid Utility Account.</mat-error>
      <pre style="font-size: 12px;">{{(this.getFullValidationMessage(utilityAccounts[utilityAccounts.length -1]) | async)}}</pre>
      <pre style="font-size: 12px;">{{(this.getFullValidationMessage(newAccountsData) | async)}}</pre>
    </div>
  </div>
</section>
